import { MapPin, MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";
import { useSite } from "@/context/SiteContext";
import { Logo } from "@/components/site/Logo";
import { useNav } from "@/components/site/Header";
import { InstagramIcon, TikTokIcon } from "@/components/site/SocialIcons";

export const Footer = () => {
  const { site, openInquiry } = useSite();
  const s = site.settings;
  const nav = useNav();
  return (
    <footer className="border-t border-nanina-line bg-white" data-testid="site-footer">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 py-8 grid md:grid-cols-[1.2fr_1fr_.8fr] gap-6 text-sm">
        <div>
          <Logo size="sm" testId="footer-logo" />
          <p className="mt-3 flex gap-2 text-xs text-nanina-muted leading-relaxed" data-testid="footer-address">
            <MapPin className="h-4 w-4 shrink-0 text-nanina-fresh" />{s.address}
          </p>
          {s.maps_url && <a href={s.maps_url} target="_blank" rel="noopener noreferrer" className="mt-2 inline-block text-xs font-semibold text-nanina-green underline-offset-2 hover:underline" data-testid="footer-maps-link">Lihat Lokasi di Google Maps</a>}
        </div>
        <nav className="grid grid-cols-2 gap-2 text-xs" aria-label="Navigasi footer">
          {nav.map((n) => <a key={n.id} href={n.href} className="text-nanina-muted hover:text-nanina-green">{n.label}</a>)}
        </nav>
        <div className="flex flex-col gap-2 text-xs">
          <button onClick={() => openInquiry()} className="flex items-center gap-2 text-nanina-green font-semibold text-left" data-testid="footer-whatsapp-button"><MessageCircle className="h-4 w-4" /> {s.whatsapp_display}</button>
          {s.instagram_url && <a href={s.instagram_url} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-nanina-muted hover:text-nanina-green" data-testid="footer-instagram-link"><InstagramIcon /> {s.instagram_handle || "Instagram"}</a>}
          {s.tiktok_url && <a href={s.tiktok_url} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-nanina-muted hover:text-nanina-green" data-testid="footer-tiktok-link"><TikTokIcon /> {s.tiktok_handle || "TikTok"}</a>}
        </div>
      </div>
      <div className="border-t border-nanina-line">
        <div className="mx-auto max-w-6xl px-4 sm:px-6 py-4 flex flex-wrap justify-between gap-2 text-[11px] text-nanina-muted">
          <span>© {new Date().getFullYear()} Nanina Care · Yogyakarta</span>
          <Link to="/admin/login" className="hover:text-nanina-green" data-testid="footer-admin-link">Admin</Link>
        </div>
      </div>
    </footer>
  );
};
